<article>
	<header>
		<div class="row">
			<div class="col-md-6">
				<h3>
					Промопульт
				</h3>
			</div>
			
			<div class="col-md-6 text-right">
				<a
					href="https://app01.promopult.org/admin/report/billing"
					rel="noreferrer"
					target="_blank"
				>
					Сравнить данные на стороне PromoPult
				</a>
			</div>
		</div>
	</header>
	
	<section>
		<cache-date></cache-date>
	</section>
	
	<section>
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</section>
	
	<section>
		<period></period>
		
		<div class="alert alert-warning" role="alert">
			Группировка работает только для графиков!
		</div>
	</section>
	
	<section>
		<chart
			[data]="regAndPaidChart.data"
			[options]="regAndPaidChart.options"
			[sextant]="'regAndPaidChart'"
		></chart>
		
		<hr/>
	</section>
	
	<section>
		<chart
			[data]="firstAndManualChart.data"
			[options]="firstAndManualChart.options"
			[sextant]="'firstAndManualChart'"
		></chart>
		
		<hr/>
	</section>
	
	<section>
		<chart
			[data]="siteChart.data"
			[options]="siteChart.options"
			[sextant]="'siteChart'"
		></chart>
		
		<hr/>
	</section>
	
	<section>
		<h4>
			{{ 'adminstat.common.Total info' | translate }}
		</h4>

		<loading [isLoad]="totalStatLoader"></loading>
		
		<table class="table" [sextant]="'promopultTotalStats'">
			<thead>
				<tr>
					<th>Пользователей</th>
					<th>Сайтов</th>
					<th>Первый ручной</th>
					<th>Повторный ручной</th>
					<th>Зачислено</th>
					<th>Максимальная комиссия uKit</th>
					<th>%</th>
					<th>Потрачено</th>
					<th>Текущая комиссия</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let promopultTotalStat of promopultTotalStats">
					<td>{{ promopultTotalStat.userCount }}</td>
					<td>{{ promopultTotalStat.siteCount }}</td>
					<td>{{ promopultTotalStat.firstManualPaidCount }}</td>
					<td>{{ promopultTotalStat.secondManualPaidCount }}</td>
					<td>{{ promopultTotalStat.moneyCount | numberFormat: '1.0-0' }}</td>
					<td>{{ promopultTotalStat.commission | numberFormat: '1.0-0' }}</td>
					<td>{{ 100 * promopultTotalStat.expense / promopultTotalStat.moneyCount | numberFormat: '1.2-2' }}</td>
					<td>{{ promopultTotalStat.expense | numberFormat: '1.0-0' }}</td>
					<td>{{ promopultTotalStat.commissionMoneyCount | numberFormat: '1.0-0' }}</td>
				</tr>
			</tbody>
		</table>
		
		<loading [isLoad]="statsLoader"></loading>
		
		<table class="table" [sextant]="'promopultStats'">
			<thead>
				<tr>
					<th>
						{{ 'adminstat.billing.expired_paid.pay date' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.common.userCount' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.billing.billing.firstPaidCount' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.billing.billing.repeatPaidCount' | translate }}
					</th>
					
					<th>
						Зачислено
					</th>

					<th title="Зачислено * Комиссия uKit">
						Максимальная комиссия uKit
					</th>
					
					<th>
						Потрачено
					</th>
					
					<th>
						Текущая комиссия
					</th>
				</tr>
			</thead>
			
			<tbody>
				<tr *ngFor="let stat of promopultStats">
					<td>
						{{ stat.timestamp | dateFormat }}
					</td>
					
					<td>
						{{ stat.userCount }}
					</td>
					
					<td>
						{{ stat.firstManualPaidCount }}
					</td>
					
					<td>
						{{ stat.secondManualPaidCount }}
					</td>
					
					<td>
						{{ stat.moneyCount | numberFormat: '1.2-2' }}
					</td>

					<td>
						{{ stat.commissionMoneyCount | numberFormat: '1.2-2' }}
					</td>
					
					<td>
						{{ stat.expense | numberFormat: '1.2-2' }}
					</td>
					
					<td title="Коммисия в этом месяце равна {{ stat.commission }} %">
						{{ stat.expense * stat.commission / 100 |  numberFormat: '1.2-2' }}
					</td>
				</tr>
			</tbody>
		</table>
		
		<hr/>
	</section>
	
	
	
	<section>
		<h4>
			{{ 'adminstat.common.sites' | translate }}
		</h4>
		
		<loading [isLoad]="statsLoader2"></loading>
		
		<ngb-pagination
			[collectionSize]="pagination.pageCount"
			[(page)]="pagination.page"
			(pageChange)="onPageChange()"
			[maxSize]="10"
			[pageSize]="1"
			*ngIf="pagination.pageCount > 1"
		></ngb-pagination>
		
		<table class="table" [sextant]="'siteStats'">
			<thead>
				<tr>
					<th>
						{{ 'adminstat.billing.expired_paid.pay date' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.filterForm.dateSiteCreated' | translate }}
					</th>
					
					<th>
						{{'adminstat.support.support.primaryDomain' | translate }}
					</th>
					
					<th>
						{{'adminstat.common.invoiceNumber' | translate }}
					</th>
					
					<th>
						Зачислили
					</th>
					
					<th>
						Комиссия uKit
					</th>
				</tr>
			</thead>
			
			<tbody>
				<tr *ngFor="let stat of siteStats">
					<td>
						{{ stat.paid.transaction_date | dateFormat }}
					</td>
					
					<td>
						{{ stat.site.dateCreate | dateFormat }}
					</td>
					
					<td>
						<site_info
							[siteUrl]="stat.site.domainUrl"
							[config]="{dashboardUrl: helper.site.getDomainUrl(stat.site)}"
						></site_info>
					</td>
					
					<td>
						{{ stat.invoice.invoiceNumber }}
					</td>
					
					<td>
						{{ stat.moneyCount | numberFormat: '1.2-2' }}
					</td>
					
					<td>
						{{ stat.commissionMoneyCount | numberFormat: '1.2-2' }}
					</td>
				</tr>
			</tbody>
		</table>
		
		<hr/>
	</section>
</article>
